let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fMfL2")).then(() => parcelRequire('6xEso'));